import {setLanguage, getCurrentLanguage} from './i18n.js';

export function initHarnessFooter() {
  const year = new Date().getFullYear();
  const footer = document.createElement('footer');
  footer.className = 'harness-footer';
  footer.innerHTML = `
    <div class="container">
      <div class="harness-footer-main">
        <div class="harness-footer-brand">
          <a href="/" aria-label="Loyol Seller">
            <img src="/images/loyol-horizontal-logo-white.png" alt="Loyol" width="126" height="36" loading="lazy">
          </a>
          <p data-i18n="footerHarness.statement">A inteligência operacional do seu negócio, trabalhando em todos os canais.</p>
        </div>

        <nav class="harness-footer-nav" aria-label="Navegação da página" data-i18n-attr="aria-label:footerHarness.navAria">
          <strong data-i18n="footerHarness.navigation">NAVEGUE</strong>
          <a href="#como-funciona" data-i18n="footerHarness.how" data-track-event="cta_click" data-track-placement="footer" data-track-destination="how_it_works" data-track-intent="seller">Como funciona</a>
          <a href="#exemplo" data-i18n="footerHarness.example" data-track-event="cta_click" data-track-placement="footer" data-track-destination="example" data-track-intent="seller">Exemplo real</a>
          <a href="#modelo" data-i18n="footerHarness.offer" data-track-event="cta_click" data-track-placement="footer" data-track-destination="offer" data-track-intent="seller">Modelo comercial</a>
        </nav>

        <div class="harness-footer-contact">
          <strong data-i18n="footerHarness.contact">CONVERSE COM A GENTE</strong>
          <p data-i18n="contact.footerNote">Envie seu contexto pelo formulário. Respondemos por email.</p>
        </div>
      </div>

      <div class="harness-footer-bottom">
        <small>MOAT BUILDERS BRASIL LTDA · CNPJ 38.175.137/0001-50 · Franca, Brasil</small>
        <div class="harness-footer-languages" aria-label="Idioma" data-i18n-attr="aria-label:footerHarness.language"></div>
        <small>Loyol &copy; ${year}</small>
      </div>
    </div>
  `;
  document.body.appendChild(footer);

  const languageSelector = footer.querySelector('.harness-footer-languages');
  const languages = [
    {code: 'pt', label: 'PT'},
    {code: 'en', label: 'EN'},
    {code: 'it', label: 'IT'},
  ];

  function renderLanguageSelector() {
    const current = getCurrentLanguage();
    languageSelector.innerHTML = languages.map(language => {
      const active = language.code === current;
      return `<button type="button" data-lang="${language.code}" class="${active ? 'is-active' : ''}" aria-pressed="${active}">${language.label}</button>`;
    }).join('');
  }

  languageSelector.addEventListener('click', event => {
    const button = event.target.closest('[data-lang]');
    if (!button) return;
    setLanguage(button.dataset.lang);
    renderLanguageSelector();
  });

  document.addEventListener('loyol-lang-changed', renderLanguageSelector);
  renderLanguageSelector();
}
